import ContentMasonry from 'Components/social-account/ContentMasonry';
import PostCard from 'Components/social-account/PostCard';
import SocialPostModal from 'Components/social-account/SocialPostModal';
import React, { useEffect, useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import { fetchCampaignContent } from 'services/api/campaign';
import { setCampaignPostsFilters } from 'slices/campaigns/posts/reducer';
import { fetchCampaignPostsThunk } from 'slices/campaigns/posts/thunk';
import { closeSocialPostModal } from 'slices/ui/reducer';
import { AppDispatch, RootState } from 'store';
import { CampaignPostsFilters } from 'types/campaign/posts';
import { generateUniqueKey } from 'utils/helpers';

const CampaignContent = () => {

    const { campaignId } = useParams();
    const socialPostModal = useSelector((state: RootState) => state.ui.socialPostModal);
    const filters = useSelector((state: RootState) => state.campaignPosts.posts.filters);
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);
    const [filtersId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const loading = useSelector((state: RootState) => state.campaignPosts.posts.loading);
    const error = useSelector((state: RootState) => state.campaignPosts.posts.loading);


    const postsData = useSelector((state: RootState) => state.campaignPosts.posts.items[campaignId!]?.filtered_lists?.[filtersId!]);
    const posts = postsData?.items ?? [];
    const has_more = postsData?.has_more ?? true;
    const page = postsData?.page ?? 1;


    const [initialLoading, setInitialLoading] = useState(true);


    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        if (campaignId && filters) {
            if (filters.page && filters.page === 1) {
                setInitialLoading(true);
            }
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
                dispatch(fetchCampaignPostsThunk({ campaignId, filters })).finally(() => {
                    setInitialLoading(false);
                    setFilterId(generateUniqueKey(filters, ['page']))
                })
            }, 500)
        }
    }, [campaignId, filters])

    const nextPage = () => {
        if (has_more && campaignId && !loading) {
            const nextPageNumber = page + 1;
            dispatch(fetchCampaignPostsThunk({ filters: { ...filters, page: nextPageNumber }, campaignId }))
        }
    }

    const setFilters = (updatedFilters: CampaignPostsFilters) => {
        dispatch(setCampaignPostsFilters(updatedFilters));
    }

    return (
        <>
            <div className='p-4 pt-0 pb-5'>
                <InfiniteScroll
                    dataLength={posts.length + 1}
                    next={nextPage}
                    className=''
                    hasMore={has_more}
                    loader={<></>}
                >
                    <ContentMasonry posts={posts.map((t) => t.social_post)} isLoading={initialLoading || loading} />
                    {
                        !(loading || initialLoading) && error &&
                        <div className="d-flex justify-content-center align-items-center">
                            <button className="theme-btn theme-btn-sm btn-primary-outlined" onClick={nextPage}>Load More <i className='ms-2 fs-5 bx bx-refresh'></i></button>
                        </div>
                    }
                </InfiniteScroll>
                {
                    !(loading || initialLoading) && (posts.length === 0) &&
                    <div className="d-flex w-100 justify-content-center align-items-center">
                        <div className="length-zero">
                            <h3>Currently there is no post in your list, try adjusting filters!</h3>
                        </div>
                    </div>
                }
            </div>
            <SocialPostModal
                isOpen={!!socialPostModal}
                onClose={() => dispatch(closeSocialPostModal())}
                socialAccount={socialPostModal?.socialAccount}
                postId={socialPostModal?.postId}
                disableComments={true}
            />
        </>

    )
}

export default CampaignContent
